module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b7c940"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/components/VisCommon.vue
// module id = 384
// module chunks = 42